module.exports = __webpack_public_path__ + "img/debs.77815af3.jpg";